<!-- eslint-disable max-len -->
<template>
  <div v-if="installmentInfo" :class="['billet', { 'gray-background': installmentInfo.installmentStatus === 'PAID' }]" style="position: relative;">
    <MobileOrderDetails :open="detailsDrawerIsOpen" :orderId="installmentInfo.orderId" :purchasedDate="installmentInfo.purchasedDate" :retailerName="installmentInfo.retailerName" :products="installmentInfo.products" @onClose="closeMoreDetails" />
    <Header :centeredLogo="installmentInfo.installmentStatus === 'PAID' || (isOverdueBillet && isMobile())" />
    <div class="body-wrapper">
      <PaidBilletCard v-if="installmentInfo.installmentStatus === 'PAID'" :orderId="installmentInfo.orderId" :purchasedDate="installmentInfo.purchasedDate" :installmentNumber="installmentInfo.installmentNumber" :installmentNumbers="installmentInfo.installmentNumbers"
        :installmentValue="installmentInfo.installmentValue" :installmentDueDate="installmentInfo.installmentDueDate" :installmentPayDay="installmentInfo.installmentPayDay" />
      <div v-else class="billet-body">
        <div class="billet-body--main" :class="{ 'showing-overdue': isOverdueBillet }">
          <OverDuePage v-if="isOverdueBillet" :installmentNumber="installmentInfo.installmentNumber" :installmentNumbers="installmentInfo.installmentNumbers" @onClickInDetails="openMoreDetails" />
          <template v-else>
            <PaidWarning class="warning" v-if="installmentInfo.installmentStatus === 'PAID'" />
            <DueDateWarning class="warning" v-else-if="(
              installmentInfo.installmentDueDate
              && diffInDays(installmentInfo.installmentDueDate, new Date()) <= 3
            )" :diffInDays="diffInDays(installmentInfo.installmentDueDate, new Date())" />
            <h3 class="billet-body--title" :class="{ 'with-warning': showingWarning }">
              Pagamento da parcela {{
                installmentInfo.installmentNumber | leadZeroFilter
              }}/{{ installmentInfo.installmentNumbers | leadZeroFilter }}

              <a class="more-details" @click="openMoreDetails">Detalhes do pedido</a>
            </h3>
            <div class="billet-body--value">
              <span class="title">Valor</span>
              <span class="value">{{ installmentInfo.installmentValue | moneyFilter }}</span>
            </div>
            <div class="billet-body--due_date">
              <span class="title">Vencimento</span>
              <span class="value">{{ installmentInfo.installmentDueDate | dateFilter }}</span>
            </div>
            <Selector name="Pix" iconName="pix-icon.svg" iconDir="icons" :checked="downPaymentOption === 'pix'" @click="handleChangeDownPaymentOption('pix')" />
            <Selector name="Boleto" iconName="boleto-icon.svg" iconDir="icons" :checked="downPaymentOption === 'billet'" @click="handleChangeDownPaymentOption('billet')" />
            <PixDescription v-if="downPaymentOption === 'pix'" :pixCode="installmentInfo.pixCode" :loading="isLoading" />
            <BilletDescription v-if="downPaymentOption === 'billet'" :barcodeNumber="installmentInfo.barcodeNumber" :payNumber="installmentInfo.payNumber" :loading="isLoading" :downloadFileName="`${installmentInfo.orderId}_BOLETO_PARCELA_${installmentInfo.installmentNumber}`"
              :billetLink="installmentInfo.installmentLink" :installmentsLink="installmentInfo.installmentsLink" :billetUserId="installmentInfo.userId" />
          </template>

        </div>
        <DesktopContainer :orderId="installmentInfo.orderId" :purchasedDate="installmentInfo.purchasedDate" :installmentNumber="installmentInfo.installmentNumber" :installmentNumbers="installmentInfo.installmentNumbers" :installmentValue="installmentInfo.installmentValue"
          :installmentDueDate="installmentInfo.installmentDueDate" :retailerName="installmentInfo.retailerName" :products="installmentInfo.products" :loading="isLoading" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import moment from 'moment';
import StringMixin from '@/mixins/string';
import UtilMixin from '@/mixins/util';
import Header from '../components/Header.vue';
import DueDateWarning from '../components/DueDateWarning.vue';
import PaidWarning from '../components/PaidWarning.vue';
import Selector from '../components/Selector.vue';
import PixDescription from '../components/PixDescription.vue';
import BilletDescription from '../components/BilletDescription.vue';
import DesktopContainer from '../components/DesktopContainer.vue';
import PaidBilletCard from '../components/PaidBilletCard.vue';
import installmentsService from '../installments.service';
import MobileOrderDetails from '../components/MobileOrderDetails.vue';
import OverDuePage from '../components/OverduePage.vue';
import ParcelexApi from '../../../services/parcelex';

export default {
  metaInfo: {
    titleTemplate: 'Meu Parcelex | Boleto',
  },
  components: {
    Header,
    DueDateWarning,
    PaidWarning,
    Selector,
    PixDescription,
    BilletDescription,
    DesktopContainer,
    PaidBilletCard,
    MobileOrderDetails,
    OverDuePage,
  },
  data: () => ({
    downPaymentOption: 'pix',
    installmentInfo: null,
    detailsDrawerIsOpen: false,
  }),
  computed: {
    ...mapState('installments', ['isLoading']),
    showingWarning() {
      if (!this.installmentInfo) return false;
      const { installmentStatus, installmentDueDate } = this.installmentInfo;
      return installmentStatus === 'PAID' || (installmentDueDate && this.diffInDays(installmentDueDate, new Date()) <= 3);
    },
    isOverdueBillet() {
      if (!this.installmentInfo) return false;
      const { installmentStatus, installmentDueDate } = this.installmentInfo;
      return installmentStatus !== 'PAID' && installmentDueDate && this.diffInDays(new Date(), installmentDueDate) > 29;
    },
  },
  methods: {
    ...mapActions('installments', ['setIsLoading']),
    ...mapActions('auth', ['setToken']),
    handleChangeDownPaymentOption(paymentOption) {
      this.downPaymentOption = paymentOption;
    },
    diffInDays(start, end) {
      return moment(start).endOf('day').diff(moment(end).endOf('day'), 'days');
    },
    openMoreDetails() {
      this.detailsDrawerIsOpen = true;
    },
    closeMoreDetails() {
      this.detailsDrawerIsOpen = false;
    },
    async sendEvent({ action, data }) {
      const { query } = this.$route;

      ParcelexApi.post('public/event/send', {
        action,
        source: 'billet-page',
        origin: window.location.href.split('?')[0],
        data: {
          ...data,
          ...query,
        },
      }).catch((e) => console.error(e));
    },
  },
  mixins: [StringMixin, UtilMixin],
  async mounted() {
    this.setIsLoading(true);
    const { token } = this.$route.query;
    if (!token) {
      this.$router.push({ path: '/boleto/nao-encontrado' });
      return;
    }
    const [installmentId, transactionIdWithQuery] = token.split(':');
    const [transactionId] = transactionIdWithQuery.split('?');

    if (!installmentId || !transactionId) {
      this.$router.push({ path: '/boleto/nao-encontrado' });
      return;
    }
    try {
      const { data } = await installmentsService
        .getInstallmentData({ installmentId, transactionId });
      this.installmentInfo = data;
      this.sendEvent({
        action: 'visualizou-pagina-pagamento',
        data: {
          id: transactionId,
          transactionId,
          installmentId,
          orderId: data.orderId,
          purchasedDate: data.purchasedDate,
          installmentNumber: data.installmentNumber,
          installmentNumbers: data.installmentNumbers,
          installmentValue: data.installmentValue,
          installmentDueDate: data.installmentDueDate,
          installmentPayDay: data.installmentPayDay,
        },
      });
      this.setIsLoading(false);
    } catch (error) {
      if (error.response && error.response.data === 'jwt expired') {
        this.setToken({ token: null });
        this.$router.replace({ path: '/login' });
      } else {
        this.$router.replace({ path: '/boleto/nao-encontrado' });
      }
      this.setIsLoading(false);
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/__new-styles.scss';

.billet {
  display: grid;
  height: 100vh;
  grid-template-rows: auto 1fr auto;

  position: relative;
  overflow-x: hidden;

  @media (min-width: $md) {
    grid-template-rows: auto 1fr;
  }

  @media (min-width: $lg) {
    overflow-x: auto;
  }
}

.gray-background {
  background-color: var(--gray-100);
}

.body-wrapper {
  display: flex;
  justify-content: center;
}

.billet-body {
  padding: 24px;
  color: var(--gray-700);

  width: 100%;

  @media (min-width: 526px) {
    max-width: 486px;
    padding-left: unset;
    padding-right: unset;
  }

  @media (min-width: $lg) {
    max-width: 964px;
    display: flex;
    gap: 36px;
  }
}

.billet-body--title {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 20px;
  font-family: var(--font-family);
  grid-column-start: 1;
  grid-column-end: 3;
  font-size: 18px;
  line-height: 24px;

  &.with-warning {
    margin-top: 52px;
  }

  @media (min-width: $lg) {
    &.with-warning {
      margin: 0;
    }
  }

  .more-details {
    @extend .small-regular;

    color: var(--primary);

    font-size: 16px;
    line-height: 24px;
    font-weight: 400;
  }

  &.skeleton {
    width: 100%;
    margin-bottom: 20px;
    height: 32px;
  }

  @media (min-width: $lg) {
    padding-bottom: 24px;
    font-size: 20px;

    .more-details {
      display: none;
    }

    &.skeleton {
      margin-bottom: 24px;
    }
  }
}

.billet-body--main {
  display: grid;
  column-gap: 16px;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: repeat(4, max-content);

  &.showing-overdue {
    grid-template-columns: 1fr;
  }

  @media (min-width: $lg) {
    max-width: 486px;
    width: 100%;
    column-gap: 20px;
  }

  .title {
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    margin-bottom: 4px;
  }

  .value {
    font-size: 16px;
    line-height: 24px;
    font-weight: 700;
    margin-bottom: 20px;

    &.skeleton {
      width: 100%;
      height: 100%;
    }
  }

  .billet-body--value,
  .billet-body--due_date {
    display: flex;
    flex-direction: column;
  }
}

.display-none {
  display: none !important;
}

.installments-footer {
  display: flex;
  justify-content: center;
  align-items: center;

  line-height: 24px;
  padding-bottom: 20px;

  a {
    text-decoration: none;
    -webkit-tap-highlight-color: transparent;
  }

  @media (min-width: $lg) {
    display: none;
  }
}
</style>
